import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import AOS from 'aos';
import 'aos/dist/aos.css';
// import router from "./router.js"

import VueI18n from 'vue-i18n'
import LangEn from './language/en_US'
import LangZhCN from './language/zh_CN'
import LangZhHK from './language/zh_HK'
import defined from './javascripts/defined.js'
import router from "./javascripts/router.js"
import comment from "./javascripts/comment.js"
import './style/font.css'
import './style/style.scss'
import './style/swiper.min.css'
import api from './javascripts/apiCall.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

// Vue.config.productionTip = false
Vue.prototype.api = api
Vue.prototype.comment = comment


import VModal from 'vue-js-modal'
Vue.use(VModal, {
  dialog: true,
  dynamic: true,
})
Vue.use(VueI18n)
Vue.use(Vuex)
const store = new Vuex.Store(defined)

const i18n = new VueI18n({
  locale: 'en_US',
  messages: {
    'en_US': LangEn,
    'zh_CN': LangZhCN,
    'zh_HK': LangZhHK
  }
})
var app = new Vue({
  router,
  i18n,
  store,
  created() {
    AOS.init()
  },
  render: h => h(App),
}).$mount('#app')


